import { render, staticRenderFns } from "./RMOrdersList.vue?vue&type=template&id=3b53c703&scoped=true"
import script from "./RMOrdersList.vue?vue&type=script&lang=js"
export * from "./RMOrdersList.vue?vue&type=script&lang=js"
import style0 from "./RMOrdersList.vue?vue&type=style&index=0&id=3b53c703&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b53c703",
  null
  
)

export default component.exports